module.exports = __webpack_public_path__ + "8ac353d6112f50b3b6ef89cf0c5d3355.png";